import { NavLink } from "react-router-dom";
import { useIsAuthorized } from "../authz/useIsAuthorized";

/**
 * 60px navy sidebar matching the xCures prototype shell
 * (`requirements/ui-patterns.md`). Logo tile at the top, an icon stack
 * for the app's primary destinations, a flexible spacer, and reserved
 * space below for future utility icons (settings, help).
 *
 * PRD-005 ADR §7 hidden-nav: the export icons are not rendered at all
 * for users without `Subject_Read`. Disabled-with-tooltip would leak the
 * feature's existence to users who shouldn't have it (discoverability
 * leak; support-ticket generator). Deep-link / mid-session revocation
 * still routes to the deny page via AuthorizedGate.
 */
export function Sidebar() {
    const authorized = useIsAuthorized();
    return (
        <nav className="sidebar" aria-label="Primary">
            <div className="sidebar-logo" aria-label="xCures">
                xC
            </div>
            <div className="sidebar-div" />
            {authorized && (
                <>
                    <NavLink
                        to="/"
                        end
                        className={({ isActive }) =>
                            isActive ? "sidebar-icon active" : "sidebar-icon"
                        }
                        aria-label="New export"
                        title="New export"
                    >
                        <i className="fa-solid fa-file-export" aria-hidden="true" />
                    </NavLink>
                    <NavLink
                        to="/jobs"
                        className={({ isActive }) =>
                            isActive ? "sidebar-icon active" : "sidebar-icon"
                        }
                        aria-label="Job history"
                        title="Job history"
                    >
                        <i className="fa-solid fa-clock-rotate-left" aria-hidden="true" />
                    </NavLink>
                </>
            )}
            <div className="sidebar-spacer" />
        </nav>
    );
}
